import IconBase from "./IconBase";

// The same container as Content, holding an image instead of records — the
// frame is the family trait, the interior says what lives inside.
const MediaIcon = (props) => (
    <IconBase {...props}>
        <rect x="3" y="3" width="18" height="18" rx="3.5" />
        <circle cx="9" cy="9" r="1.9" />
        <path d="M3.5 17.5L8 13a2 2 0 0 1 2.8 0l5.7 5.7" />
        <path d="M14 16.2l1.7-1.7a2 2 0 0 1 2.8 0l2.1 2.1" />
    </IconBase>
);

export default MediaIcon;
